import { render, staticRenderFns } from "./hospitalarchivestable.vue?vue&type=template&id=4645050d&scoped=true&"
import script from "./hospitalarchivestable.vue?vue&type=script&lang=js&"
export * from "./hospitalarchivestable.vue?vue&type=script&lang=js&"
import style0 from "./hospitalarchivestable.vue?vue&type=style&index=0&id=4645050d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4645050d",
  null
  
)

export default component.exports